export const defaultKnowledgeConfiguration = (requirement = "optional") => ({
  mode: requirement === "required" ? "required" : "disabled",
  knowledgeBaseIds: [],
  fallbackAction: requirement === "required" ? "clarify" : "continue",
  fallbackQueueId: "",
});

export const knowledgeConfigurationFromPrompt = (prompt = {}, requirement = "optional") => {
  const defaults = defaultKnowledgeConfiguration(requirement);
  const knowledge = prompt.knowledge || {};
  return {
    ...defaults,
    mode: knowledge.mode || defaults.mode,
    knowledgeBaseIds: (knowledge.bases || []).map((base) => base.id),
    fallbackAction: knowledge.fallbackAction || defaults.fallbackAction,
    fallbackQueueId: knowledge.fallbackQueueId || "",
  };
};

export const buildKnowledgePayload = (configuration = {}) => ({
  mode: configuration.mode || "disabled",
  knowledgeBaseIds:
    configuration.mode === "disabled"
      ? []
      : Array.from(new Set(configuration.knowledgeBaseIds || [])),
  fallbackAction:
    configuration.mode === "disabled"
      ? "continue"
      : configuration.fallbackAction ||
        (configuration.mode === "required" ? "clarify" : "continue"),
  fallbackQueueId:
    configuration.mode !== "disabled" &&
    configuration.fallbackAction === "handoff" &&
    configuration.fallbackQueueId
      ? Number(configuration.fallbackQueueId)
      : null,
});

export const knowledgeBaseDisabledReason = (base, selectedProfileId) => {
  if (!base?.isReady) {
    if (base?.status && base.status !== "active") return "Esta base está inativa.";
    if (base?.readySourceCount === 0) return "Nenhuma fonte aprovada está disponível no índice atual.";
    return "A base está indisponível. Confira as fontes, o perfil e a credencial nos detalhes.";
  }
  if (
    selectedProfileId &&
    Number(base.embeddingProfileId) !== Number(selectedProfileId)
  ) {
    return "O perfil de embeddings é incompatível com as bases já selecionadas.";
  }
  return "";
};
